import firebase from 'firebase/app'
import 'firebase/database'

var config = {
  apiKey: "AIzaSyCTmhgJifN-1IQV_16_lHfuVSbdWZgLKUk",
  authDomain: "maranimals-1491246486390.firebaseapp.com",
  databaseURL: "https://maranimals-1491246486390.firebaseio.com",
  projectId: "maranimals-1491246486390",
  storageBucket: "maranimals-1491246486390.appspot.com",
  messagingSenderId: "601545853003"
};
firebase.initializeApp(config);

export default firebase.database()